import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterPlayerFormChangedEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}